<template>
  <transition leave-active-class="duration-200">
    <div
      @keydown="$refs.progressbar.userKeyDown()"
      @keyup="$refs.progressbar.userKeyUp()"
      @click="calculate_progress"
      v-if="showing === true && loadingData === false"
      class="z-50 fixed bottom-0 px-4 inset-0 sm:p-0 flex items-center justify-center"
    >
      <!-- Background modal -->
      <transition
        enter-active-class="ease-out duration-300"
        enter-class="opacity-0"
        enter-to-class="opacity-100"
        leave-active-class="ease-in duration-200"
        leave-class="opacity-100"
        leave-to-class="opacity-0"
      >
        <div class="fixed inset-0 transition-opacity" @click="closePopup()">
          <div class="absolute inset-0 bg-indigo-600 bg-opacity-85" />
        </div>
      </transition>
      <!-- FIN Background modal -->

      <!-- Content modal -->
      <div
        aria-labelledby="modal-headline"
        aria-modal="true"
        class="bg-white rounded-lg px-4 pt-5 pb-4 overflow-scroll max-h-9/10 shadow-xl transform transition-all lg:w-4/6 sm:w-full sm:p-6"
        role="dialog"
        @scroll="$refs.progressbar.reduceProgressBar($event)"
      >
        <div
          class="cursor-pointer absolute right-5 top-20 rounded-full px-2 py-2 bg-pink-100 text-pink-600 border border-pink-600 border-opacity-25 transition ease-in-out duration-500 hover:text-white hover:bg-pink-600"
          @click="closePopup()"
        >
          <icon name="close" />
        </div>
        <div class="sticky top-0 z-10">
          <transition
            enter-active-class="ease-out duration-300"
            enter-class="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            enter-to-class="opacity-100 translate-y-0 sm:scale-100"
            leave-active-class="ease-in duration-200"
            leave-class="opacity-100 translate-y-0 sm:scale-100"
            leave-to-class="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
          >
            <div
              v-if="messageHeader.type != '' && messageHeader.msg != ''"
              :class="{
                'bg-green-300 border-2 border-green-600 border-opacity-25 text-green-600':
                  messageHeader == 'saveIsSuccess' ||
                  messageHeader == 'transferIsSuccess',
                'bg-pink-300 border-2 border-pink-600 border-opacity-25 text-pink-600':
                  messageHeader == 'error' ||
                  messageHeader == 'noName' ||
                  messageHeader == 'lastActivity' ||
                  messageHeader === 'evaluationInProgress',
                'bg-amber-100 border-2 border-amber-600 border-opacity-25 text-amber-600':
                  messageHeader == 'noSave',
              }"
              class="absolute text-center py-5 mt-10 w-6/12 left-3/12 right-3/12 text-base flex items-center justify-center"
            >
              <div>
                <div class="flex items-center justify-center">
                  <icon
                    v-if="
                      messageHeader == 'saveIsSuccess' ||
                      messageHeader == 'transferIsSuccess'
                    "
                    name="checkmark-circle-2"
                    class="inline-block mr-2"
                  />
                  <icon
                    v-else-if="
                      messageHeader == 'error' ||
                      messageHeader == 'noName' ||
                      messageHeader == 'lastActivity'
                    "
                    name="alert-triangle"
                    class="inline-block mr-2"
                  />
                  <icon
                    v-else-if="messageHeader == 'noSave'"
                    name="alert-triangle"
                    class="inline-block mr-2"
                  />

                  <div v-if="messageHeader == 'saveIsSuccess'">
                    Vos données ont été enregistrées.
                  </div>
                  <div v-if="messageHeader == 'transferIsSuccess'">
                    La fiche de poste à bien été transférée.
                  </div>
                  <div v-if="messageHeader == 'evaluationInProgress'">
                    Vous ne pouvez pas modifier une fiche de poste utilisée par
                    une évaluation.
                  </div>
                  <div v-if="messageHeader == 'error'">
                    Erreur d'enregistrement des données.
                  </div>
                  <div v-if="messageHeader == 'lastActivity'">
                    Vous ne pouvez pas supprimer la dernière activité.
                  </div>
                  <div v-if="messageHeader == 'noName'">
                    Veuillez remplir le champ "nom du poste"
                    <br>
                    pour enregistrer la fiche.
                  </div>
                  <div v-if="messageHeader == 'noSave'">
                    Vous avez des modifications non sauvegardées.<br>
                  </div>
                </div>

                <div v-if="messageHeader == 'noSave'" class="mt-5">
                  <button
                    @click="cancel_nosave()"
                    class="border-amber-600 border-opacity-25 text-amber-600 bg-amber-100 border-2 rounded-md transform hover:scale-110 duration-300 text-base p-2 mr-4"
                  >
                    ANNULER
                  </button>

                  <button
                    @click="closeWithoutSaving()"
                    class="bg-amber-600 text-amber-100 border-amber-100 border-opacity-25 border-2 rounded-md transform hover:scale-110 duration-300 text-base p-2"
                  >
                    QUITTER
                  </button>
                </div>
              </div>
            </div>
          </transition>
          <!-- Save button -->
          <div
            v-if="
              editable &&
              ($can(constants.PERMISSION_FICHE_DE_POSTE_PERSONNELLE_EDITER) ||
                $can(
                  constants.PERMISSION_REFERENTIEL_FORMATION_PERSONNELLE_EDITER
                ))
            "
            class="absolute right-15 mt-13 rounded-full cursor-pointer bg-pink-600 hover:shadow-pink text-white w-14 h-14"
            @click="save_datas"
          >
            <icon name="save" class="h-6 w-6 ml-4 mt-1/4" />
          </div>
          <div
            v-else-if="
              (!editable &&
                $can(constants.PERMISSION_FICHE_DE_POSTE_COMMUNE_EDITER)) ||
              $can(constants.PERMISSION_REFERENTIEL_FORMATION_COMMUNE_EDITER)
            "
            class="absolute right-15 mt-13 rounded-full cursor-pointer bg-pink-600 hover:shadow-pink text-white w-14 h-14"
            @click="save_datas"
          >
            <icon name="save" class="h-6 w-6 ml-4 mt-1/4" />
          </div>
        </div>

        <!-- Progress bar -->
        <progress-bar v-if="editable" ref="progressbar" :in-popup="true" />
        <!-- End Progress bar -->

        <!-- Content form -->
        <div class="m-5 md:mx-15 md:mt-15 md:mb-0 grid grid-cols-12">
          <h3 class="col-span-full">
            {{ form.nom_du_poste }}
          </h3>

          <!-- BEGIN informations de base -->
          <h4 class="col-span-full text-indigo-600 my-10">
            Informations de base
          </h4>

          <div class="col-span-full grid grid-cols-12 gap-4">
            <input-text
              :class="'lg:col-span-4'"
              name="nom_du_poste"
              libelle="Nom du poste"
              :necessary="true"
              :value="form.nom_du_poste"
              @input="
                (newValue) => {
                  form.nom_du_poste = newValue;
                }
              "
              :disabled="!editable"
            />
            <input-select
              name="sector"
              libelle="Secteur d'activité"
              :necessary="true"
              :datas="categories"
              :value="form.sector"
              @input="
                (newValue) => {
                  form.sector = newValue;
                  setIndex(newValue);
                }
              "
              class="lg:col-span-4"
              :disabled="!editable"
            />
            <input-select
              name="family"
              libelle="Famille professionnelle"
              :necessary="true"
              :value="form.family"
              @input="
                (newValue) => {
                  form.family = newValue;
                }
              "
              class="lg:col-span-4"
              :datas="listDomaines"
              :disabled="!editable"
            />
            <input-text-area
              name="definition"
              libelle="Définition"
              :size="5"
              :necessary="true"
              :value="form.definition"
              @input="
                (newValue) => {
                  form.definition = newValue;
                }
              "
              class="lg:col-span-4"
              :disabled="!editable"
            />
            <input-text-area
              name="acces_emploi"
              libelle="Accès à l'emploi métier"
              :size="5"
              :necessary="true"
              :value="form.acces_emploi"
              @input="
                (newValue) => {
                  form.acces_emploi = newValue;
                }
              "
              class="lg:col-span-4"
              :disabled="!editable"
            />
            <input-text-area
              name="conditions_exercice"
              libelle="Conditions d'exercice de l'activité"
              :size="5"
              :necessary="true"
              :value="form.conditions_exercice"
              @input="
                (newValue) => {
                  form.conditions_exercice = newValue;
                }
              "
              class="lg:col-span-4"
              :disabled="!editable"
            />
            <input-text-area
              name="emplois_proches"
              libelle="Mobilité : Emplois proches"
              :size="5"
              :necessary="true"
              :value="form.emplois_proches"
              @input="
                (newValue) => {
                  form.emplois_proches = newValue;
                }
              "
              class="lg:col-span-4"
              :disabled="!editable"
            />
            <input-text-area
              name="evolutions"
              libelle="Mobilité : Emplois si évolution"
              :size="5"
              :necessary="true"
              :value="form.evolutions"
              @input="
                (newValue) => {
                  form.evolutions = newValue;
                }
              "
              class="lg:col-span-4"
              :disabled="!editable"
            />

            <!-- BEGIN Referentiels correspondants -->
            <div class="col-span-full grid grid-cols-12 gap-4 my-10">
              <h4 class="text-indigo-600 col-span-full">
                Référentiels correspondants
              </h4>
              <input-text
                class="lg:col-span-3"
                name="rome"
                libelle="ROME"
                :necessary="false"
                :value="form.rome"
                @input="
                  (newValue) => {
                    form.rome = newValue;
                  }
                "
                :disabled="!editable"
              />
              <input-text
                class="lg:col-span-3"
                name="rsfp"
                libelle="RSFP"
                :necessary="false"
                :value="form.rsfp"
                @input="
                  (newValue) => {
                    form.rsfp = newValue;
                  }
                "
                :disabled="!editable"
              />
              <input-text
                class="lg:col-span-3"
                name="rncp"
                libelle="Diplômes et titre (RNCP)"
                :necessary="false"
                :value="form.rncp"
                @input="
                  (newValue) => {
                    form.rncp = newValue;
                  }
                "
                :disabled="!editable"
              />
              <input-text
                class="lg:col-span-3"
                name="convention_collective"
                libelle="Conventions collectives"
                :necessary="false"
                :value="form.convention_collective"
                @input="
                  (newValue) => {
                    form.convention_collective = newValue;
                  }
                "
                :disabled="!editable"
              />
            </div>
            <!-- END Referentiels correspondants -->

            <!-- BEGIN compétences -->
            <div class="relative col-span-full">
              <div class="my-10">
                <!-- BEGIN dropdown choose type competences  -->
                <div
                  class="w-full flex flex-col justify-center items-center mb-10"
                >
                  <div class="max-w-8/10 flex flex-col items-end">
                    <div
                      class="flex flex-row justify-center items-center cursor-pointer w-full"
                      @click="displayTypeCompetenceslist"
                      @click.stop
                    >
                      <div class="flex flex-row items-end justify-center ml-2">
                        <h4 class="text-indigo-600 text-center select-none">
                          {{ currentTypeCompetence }}
                        </h4>
                      </div>
                      <div
                        class="text-pink-600 max-h-8 rounded-full relative flex items-center p-2 order-2"
                      >
                        <icon class="h-4 w-4" name="chevron-down" />
                      </div>
                    </div>
                    <div class="activitylist relative h-0">
                      <div
                        class="absolute w-max flex z-20 rounded-md bg-white shadow-md shadow-gray-600 text-sm right-0"
                        v-click-outside="displayTypeCompetenceslist"
                        v-if="showList"
                      >
                        <div class="mx-5 my-3">
                          <div class="text-left">
                            <div class="first:pt-2 py-1">
                              <p
                                class="text-gray-600 hover:text-gray-900 cursor-pointer"
                                @click="
                                  currentTypeCompetence = 'Compétences de base';
                                  displayTypeCompetenceslist();
                                "
                              >
                                Compétences de base
                              </p>
                              <p
                                class="text-gray-600 hover:text-gray-900 cursor-pointer"
                                @click="
                                  currentTypeCompetence =
                                    'Compétences spécifiques';
                                  displayTypeCompetenceslist();
                                "
                              >
                                Compétences spécifiques
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <!-- END dropdown choose type competences -->

                <div v-show="currentTypeCompetence === 'Compétences de base'">
                  <div class="grid grid-cols-12 gap-y-5 gap-x-10 mb-10">
                    <h5
                      class="text-left text-base uppercase text-indigo-600 col-span-full"
                    >
                      Savoir-faire
                    </h5>

                    <!-- BEGIN Liste savoir-faire -->
                    <draggable
                      v-model="form.competences_bases.savoir_faire"
                      @start="drag = true"
                      @end="drag = false"
                      v-bind="dragOptions"
                      class="col-span-full grid grid-cols-12 gap-y-5 gap-x-10"
                    >
                      <div
                        v-for="(sf, isf) in form.competences_bases.savoir_faire"
                        :key="'A' + isf"
                        class="col-span-6 flex items-center relative"
                      >
                        <input-text-with-action
                          libelle=""
                          :name="'sf' + isf"
                          :necessary="true"
                          :value="sf"
                          :disabled="!editable"
                          :is-grabable="true"
                          :style="editable ? 'cursor:grab' : ''"
                          @input="
                            (newValue) => {
                              sf = newValue;
                            }
                          "
                          @switchDraggable="
                            (newValue) => {
                              isDraggable = newValue;
                            }
                          "
                          @duplicate="
                            duplicateSavoirFaire(sf, isf, 'competences_bases')
                          "
                          @delete="
                            deleteFromCompetence(
                              form.competences_bases.savoir_faire,
                              isf
                            )
                          "
                          :draggable="true"
                          placeholder="Saisir le nom du savoir-faire"
                          :prefix-text="isf + 1 + '. '"
                          :class="{
                            'animate-pulse transition duration-1000 ease-linear bg-indigo-600 bg-opacity-50':
                              isFlash.sf == index,
                          }"
                        />
                      </div>
                    </draggable>
                    <!-- END Liste savoir-faire -->

                    <add-button
                      libelle="Ajouter un savoir-faire"
                      :disabled="!editable"
                      @add="
                        addToCompetence(form.competences_bases.savoir_faire)
                      "
                      class="col-span-full flex items-center w-max"
                    />
                  </div>

                  <div class="grid grid-cols-12 gap-y-5 gap-x-10 mb-10">
                    <h5
                      class="text-left text-base uppercase text-indigo-600 col-span-full"
                    >
                      Savoirs
                    </h5>

                    <!-- BEGIN Liste savoirs -->
                    <draggable
                      v-model="form.competences_bases.savoirs"
                      @start="drag = true"
                      @end="drag = false"
                      v-bind="dragOptions"
                      class="col-span-full grid grid-cols-12 gap-y-5 gap-x-10"
                    >
                      <div
                        v-for="(savoir, is) in form.competences_bases.savoirs"
                        :key="'A' + is"
                        class="col-span-6 flex items-center relative"
                      >
                        <input-text-with-action
                          libelle=""
                          :name="'savoir' + is"
                          :necessary="true"
                          :value="savoir"
                          :disabled="!editable"
                          :is-grabable="true"
                          :style="editable ? 'cursor:grab' : ''"
                          @input="
                            (newValue) => {
                              savoir = newValue;
                            }
                          "
                          @switchDraggable="
                            (newValue) => {
                              isDraggable = newValue;
                            }
                          "
                          @duplicate="
                            duplicateSavoir(savoir, is, 'competences_bases')
                          "
                          @delete="
                            deleteFromCompetence(
                              form.competences_bases.savoirs,
                              is
                            )
                          "
                          :draggable="true"
                          placeholder="Saisir le nom du savoir"
                          :prefix-text="is + 1 + '. '"
                          :class="{
                            'animate-pulse transition duration-1000 ease-linear bg-indigo-600 bg-opacity-50':
                              isFlash.sf == index,
                          }"
                        />
                      </div>
                    </draggable>
                    <!-- END Liste des savoirs -->

                    <add-button
                      libelle="Ajouter un savoir"
                      :disabled="!editable"
                      @add="addToCompetence(form.competences_bases.savoirs)"
                      class="col-span-full flex items-center w-max"
                    />
                  </div>
                </div>
                <div
                  v-show="currentTypeCompetence === 'Compétences spécifiques'"
                >
                  <div class="grid grid-cols-12 gap-y-5 gap-x-10 mb-10">
                    <h5
                      class="text-left text-base uppercase text-indigo-600 col-span-full"
                    >
                      Savoir-faire
                    </h5>

                    <!-- BEGIN Liste savoir-faire -->
                    <draggable
                      v-model="form.competences_spe.savoir_faire"
                      @start="drag = true"
                      @end="drag = false"
                      v-bind="dragOptions"
                      class="col-span-full grid grid-cols-12 gap-y-5 gap-x-10"
                    >
                      <div
                        v-for="(sf, isf) in form.competences_spe.savoir_faire"
                        :key="'A' + isf"
                        class="col-span-6 flex items-center relative"
                      >
                        <input-text-with-action
                          libelle=""
                          :name="'sf' + isf"
                          :necessary="true"
                          :value="sf"
                          :disabled="!editable"
                          :is-grabable="true"
                          :style="editable ? 'cursor:grab' : ''"
                          @input="
                            (newValue) => {
                              sf = newValue;
                            }
                          "
                          @switchDraggable="
                            (newValue) => {
                              isDraggable = newValue;
                            }
                          "
                          @duplicate="
                            duplicateSavoirFaire(sf, isf, 'competences_spe')
                          "
                          @delete="
                            deleteFromCompetence(
                              form.competences_spe.savoir_faire,
                              isf
                            )
                          "
                          :draggable="true"
                          placeholder="Saisir le nom du savoir-faire"
                          :prefix-text="isf + 1 + '. '"
                          :class="{
                            'animate-pulse transition duration-1000 ease-linear bg-indigo-600 bg-opacity-50':
                              isFlash.sf == index,
                          }"
                        />
                      </div>
                    </draggable>
                    <!-- END Liste savoir-faire -->

                    <add-button
                      libelle="Ajouter un savoir-faire"
                      :disabled="!editable"
                      @add="addToCompetence(form.competences_spe.savoir_faire)"
                      class="col-span-full flex items-center w-max"
                    />
                  </div>

                  <div class="grid grid-cols-12 gap-y-5 gap-x-10 mb-10">
                    <h5
                      class="text-left text-base uppercase text-indigo-600 col-span-full"
                    >
                      Savoirs
                    </h5>

                    <!-- BEGIN Liste savoirs -->
                    <draggable
                      v-model="form.competences_spe.savoirs"
                      @start="drag = true"
                      @end="drag = false"
                      v-bind="dragOptions"
                      class="col-span-full grid grid-cols-12 gap-y-5 gap-x-10"
                    >
                      <div
                        v-for="(savoir, is) in form.competences_spe.savoirs"
                        :key="'A' + is"
                        class="col-span-6 flex items-center relative"
                      >
                        <input-text-with-action
                          libelle=""
                          :name="'savoir' + is"
                          :necessary="true"
                          :value="savoir"
                          :disabled="!editable"
                          :is-grabable="true"
                          :style="editable ? 'cursor:grab' : ''"
                          @input="
                            (newValue) => {
                              savoir = newValue;
                            }
                          "
                          @switchDraggable="
                            (newValue) => {
                              isDraggable = newValue;
                            }
                          "
                          @duplicate="
                            duplicateSavoir(savoir, is, 'competences_spe')
                          "
                          @delete="
                            deleteFromCompetence(
                              form.competences_spe.savoirs,
                              is
                            )
                          "
                          :draggable="true"
                          placeholder="Saisir le nom du savoir"
                          :prefix-text="is + 1 + '. '"
                          :class="{
                            'animate-pulse transition duration-1000 ease-linear bg-indigo-600 bg-opacity-50':
                              isFlash.sf == index,
                          }"
                        />
                      </div>
                    </draggable>
                    <!-- END Liste des savoirs -->

                    <add-button
                      libelle="Ajouter un savoir"
                      :disabled="!editable"
                      @add="addToCompetence(form.competences_spe.savoirs)"
                      class="col-span-full flex items-center w-max"
                    />
                  </div>
                </div>
              </div>
            </div>
            <!-- END Compétences -->
          </div>
          <p class="col-span-full text-center mt-10 text-sm font-light italic">
            Pôle Emploi - Données originales téléchargées via l'API
            <a
              href="https://francetravail.io/produits-partages/catalogue/rome-4-0-competences"
              target="_blank"
            >ROME</a>
          </p>
        </div>
        <!-- END Content form -->
      </div>
      <!-- END Content modal -->
    </div>
  </transition>
</template>

<script>
import Icon from '../components/Icon';
import ActionButton from '../components/ActionButton';
import AddButton from '../components/Inputs/AddButton';
import SaveButton from '../components/SaveButton';
import axios from '../api';
import { mapGetters, mapMutations, mapActions } from 'vuex';
import store from '../store';
import InputText from '../components/Inputs/InputText';
import InputTextWithAction from '../components/Inputs/InputTextWithAction';
import InputTextArea from '../components/Inputs/InputTextArea';
import MultipleSelect from '../components/Inputs/MultipleSelect';
import InputSelect from '../components/Inputs/InputSelect';
import ClickOutside from 'vue-click-outside';
import CloseButton from '../components/CloseButton';
import PageNotAllowed from '../components/PageNotAllowed';
import Popup from '../components/Popup';
import Illustration from '../components/Illustration';
import ProgressBar from './ProgressBar';

import Constants from './../constants';

import draggable from 'vuedraggable';

export default {
  props: ['show', 'id', 'openedFromEditButton'],

  components: {
    Icon,
    ActionButton,
    SaveButton,
    InputText,
    InputTextArea,
    MultipleSelect,
    AddButton,
    InputSelect,
    CloseButton,
    PageNotAllowed,
    Popup,
    Illustration,
    draggable,
    InputTextWithAction,
    ProgressBar,
  },

  name: 'PopupFicheROME',

  data() {
    return {
      loadingData: false,
      editable: true,
      smallBar: false,
      progress: 0,
      goal: 75,
      categories: [],
      showList: false,
      currentTypeCompetence: 'Compétences de base',
      messageHeader: '',
      currentSector: '',
      saved: true,
      justLoaded: false,
      form: {},
      emptyForm: {
        acces_emploi: '',
        competences_bases: {
          savoir_faire: [],
          savoirs: [],
        },
        competences_spe: {
          savoir_faire: [],
          savoirs: [],
        },
        condition_exercice: '',
        convention_collective: '',
        definition: '',
        emplois_proches: '',
        evolutions: '',
        family: '',
        nom_du_poste: '',
        rncp: '',
        rome: '',
        rsfp: '',
        sector: '',
      },
      isInvertActivitiesMenuDisplayed: false,
      isFlash: {
        sf: -1,
        savoir: -1,
      },
      isDraggable: true,
      constants: Constants,
    };
  },

  created() {
    this.initializeComponent();

    this.calculate_progress();
  },
  watch: {
    show() {
      if (this.showing) {
        console.log('etape 2 : show change');
        this.initializeJob();
      } else {
        this.unload();
      }
    },
    form: {
      handler() {
        if (this.justLoaded) {
          this.saved = true;
          this.justLoaded = false;
        } else {
          this.saved = false;
        }
      },
      deep: true,
    },
  },
  computed: {
    ...mapGetters({
      allowed: 'app/allowed',
    }),
    showing: {
      get() {
        return this.show;
      },
      set(newValue) {
        this.$emit('mutateShow', newValue);
      },
    },
    jobId: {
      get() {
        return this.id;
      },
      set(newValue) {
        this.$emit('mutateId', newValue);
      },
    },
    listDomaines() {
      if (this.currentSector == '' || this.currentSector === null) {
        let allDomaines = [];
        for (let cat in this.categories) {
          for (let st in this.categories[cat].domaines) {
            allDomaines.push({
              value: this.categories[cat].domaines[st].value,
            });
          }
        }
        allDomaines.sort(function (a, b) {
          if (a.value > b.value) {
            return 1;
          } else if (a.value < b.value) {
            return -1;
          } else {
            return 0;
          }
        });
        return allDomaines;
      } else {
        return this.categories.filter((c) => c.value == this.currentSector)[0]
          .domaines;
      }
    },
    risk(val) {
      if (val === 'Oui') {
        return true;
      }
    },

    dragOptions() {
      return {
        animation: 500,
        disabled:
          !this.editable ||
          (!this.$can(Constants.PERMISSION_FICHE_DE_POSTE_PERSONNELLE_EDITER) &&
            !this.$can(
              Constants.PERMISSION_REFERENTIEL_FORMATION_PERSONNELLE_EDITER
            )) ||
          !this.isDraggable,
        ghostClass: 'bg-indigo-300',
      };
    },
  },

  methods: {
    ...mapMutations({
      calculate_progress: 'neopass/calculate_progress',
    }),

    async load_sectors(context) {
      await axios
        .get('api/datatype/domaines')
        .then((response) => {
          this.categories = response.data.data;
        })
        .catch((error) => {
          console.log('ERRRR:: ', error.response);
        });
    },

    async save_datas() {
      if (
        this.form.nom_du_poste === '' ||
        this.form.nom_du_poste === null ||
        this.form.nom_du_poste === undefined
      ) {
        this.messageHeader = 'noName';
        setTimeout(() => {
          this.messageHeader = '';
        }, 3000);
      } else {
        await axios
          .put('/api/sheets/' + this.jobId, { data: this.form })
          .then((response) => {
            this.messageHeader = 'saveIsSuccess';
            this.saved = true;
            setTimeout(() => {
              this.messageHeader = '';
            }, 3000);
          })
          .catch((error) => {
            console.log(error.response.status);
            if (error.response.status === 403) {
              this.messageHeader = 'evaluationInProgress';
              setTimeout(() => {
                this.messageHeader = '';
              }, 3000);
              return;
            }
            this.messageHeader = 'error';
            setTimeout(() => {
              this.messageHeader = '';
            }, 3000);
            console.log('ERRRR:: ', error);
          });
      }
    },
    initializeComponent() {
      this.load_sectors();
      this.form = this.emptyForm;
    },
    setIndex(inputValue) {
      this.currentSector = inputValue;
    },

    initializeJob() {
      console.log('etape 3 : initialize job');
      if (Number.isInteger(this.jobId)) {
        this.form = this.emptyForm;
        this.editable = this.openedFromEditButton;
        this.loadData();
      } else {
        throw new Error('Trying to open a desc without giving its ID');
      }
    },
    displayTypeCompetenceslist() {
      this.showList = !this.showList;
    },

    reduceProgressBar(event) {
      let el = event.target;
      this.smallBar = el.scrollTop > 10;
    },

    closePopup() {
      if (this.saved === false) {
        this.messageHeader = 'noSave';
      } else {
        this.currentTypeCompetence = 'Compétences de base';
        this.messageHeader = '';
        this.saved = true;
        this.unload();
      }
    },
    closeWithoutSaving(e) {
      this.currentActivity = 0;
      this.messageHeader = '';
      this.saved = true;
      this.unload();
    },

    cancel_nosave() {
      this.messageHeader = '';
    },

    deleteActivity() {
      if (this.form.activities.length > 1) {
        this.form.activities.splice(this.currentActivity, 1);
        let i = this.form.activities.length - 1;
        this.currentActivity = i;
      } else {
        this.messageHeader = 'lastActivity';
        setTimeout(() => {
          this.messageHeader = '';
        }, 3000);
      }
    },
    async loadData() {
      this.loadingData = true;
      await axios
        .get('/api/sheets/' + this.jobId)
        .then((response) => {
          this.form = response.data.data;
          this.justLoaded = true;
          this.loadingData = false;
        })
        .catch((error) => {
          console.log('ERRRR:: ', error);
        });
    },
    unload() {
      this.showing = false;
    },

    addActivity() {
      let i = this.form.activities.length;
      this.form.activities.push({
        activity_comportements: [],
        activity_connaissances: [],
        activity_evolution: '',
        activity_level: '',
        activity_name: 'Nom de l\'activité',
        activity_posture: '',
        activity_pratiques_pros: [],
        activity_risk: '',
        activity_risktype: '',
        activity_situation: '',
        activity_tasks: [],
        activity_time: '',
        activity_tools: [],
      });
      this.currentActivity = i;
    },

    addToCompetence(what) {
      what.push('');
    },

    deleteFromCompetence(where, what) {
      where.splice(what, 1);
    },

    displayInvertActivitiesMenu() {
      this.isInvertActivitiesMenuDisplayed = true;
    },

    hideInvertActivitiesMenu() {
      this.isInvertActivitiesMenuDisplayed = false;
    },

    duplicateSavoirFaire(sf, index, type_competence) {
      this.form[type_competence].savoir_faire.splice(index, 0, sf);
      this.isFlash.sf = index + 1;
      setTimeout(() => {
        this.isFlash.sf = -1;
      }, 1000);
    },

    duplicateSavoir(savoir, index, type_competence) {
      this.form[type_competence].savoirs.splice(index, 0, savoir);
      this.isFlash.savoir = index + 1;
      setTimeout(() => {
        this.isFlash.savoir = -1;
      }, 1000);
    },
  },
  directives: {
    ClickOutside,
  },
};
</script>
